export interface MessageModel {
	type: MessageTypes;
	scope: MessageScopes;
	message: string;
	sendersUserId?: string;
	sendersType?: SendersTypes;
	context: MessageContext;
	readByCustomer?: Date;
	created?: Date;
	readonly schema_version?: number; //will be set by the schema in tm-server

	//exclusive mongodb fields
	_id?: string; 					//ObjectID of mongodb entry
}

export interface MessageContext
{
	id: string; 				 		// depending on type treatmentId | orderId | patientId
	customerWmsId?: string;				// customer wms id of context owner
	status?: number | string;			// status of treatment
	ticketId?: string;					// ticket id: when message is created within a ticket

	/** @deprecated Legacy since 2.5.0, do not use. */
	ownerId?: string;			 		// user id of context owner: XXX actually this should be of type 'number'
	/** @deprecated Legacy since 2.0.0, do not use. */
	dontInformMage?: boolean;    		// XXX avoids infinite event loop between magneto observer and nodeserver
	/** @deprecated Legacy since 2.0.0, do not use. */
	orderId?: string;			 		// related order if any
	/** @deprecated Legacy since 2.0.0, do not use. */
	orderStatus?: number | string;		// status of order
	/** @deprecated Legacy since 2.0.0, do not use. */
	newOrderStatus?: number | string;	// new status of order
	/** @deprecated Legacy since 2.0.0, do not use. */
	newStatus?: number | string;	 	// new status of treatment
}

export enum MessageTypes {
	Note = 0,
	Info = 1,
	Question = 2,
	Warning = 3,
	Problem = 4,
	StatusChange = 6,
	CaseWorker = 7,
	CompletionDate = 8,
	MessagesReset = 9,

	/** @deprecated legacy since 2.0.0 */
	Coupon = 5
}

export enum MessageScopes {
	Public = 0,
	Intern = 1,
	PublicWithEmailNotification = 2
}

export enum SendersTypes {
	Customer = 0,
	Technician = 1,
	System = 3,
	/** @deprecated since 2.0.0 */
	Support = 2,
}
